import axios from 'axios';

const http = axios.create({
	baseURL: 'https://wx.lg-oe.com',
	// baseURL: 'https://legion.jooneit.com',
	timeout: 10000,
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	}
});

// 请求拦截器
http.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token');
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	error => Promise.reject(error)
);

// 响应拦截器
http.interceptors.response.use(
	response => {
		const { code, result } = response.data;
		if (code === 200) return result;
		return Promise.reject(new Error(response.data.msg || 'Error'));
	},
	error => {
		if (error.response?.status === 401) {
			localStorage.removeItem('token');
			window.location.href = '/login';
		}
		return Promise.reject(error);
	}
);

export default http;